import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { FlightSidePanelDetails } from "./FlightSidePanelDetails";
import { useOpenSidePanel } from "../SidePanel";
import { useOpenNewFlightSidePanel } from "./NewFlightSidePanel";

export interface FlightSidePanelProps {
  flightId: number
  trigger: JSX.Element
}

const AddSegmentButton = ({ flightId }: { flightId: number }) => {
  const openNewFlightSidePanel = useOpenNewFlightSidePanel();

  return <ButtonSecondary label={RESX.Flight.AddSegment} onClick={() => openNewFlightSidePanel(flightId)} />
}

export const FlightSidePanel = (props: FlightSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.Flight.GetSidePanelData(props.flightId)}
    apiKey="flight"
    entityId={props.flightId}
    title={RESX.Flight.resxFlight}
    titleFunc={(data) => data.flight.flightType === "private" ? RESX.Flight.PrivateFlight : RESX.Flight.resxFlight}
    footerContent={data => <>
      {(data.flight.flightType === "commercial" && site.permissions.flight.canCreate) && <AddSegmentButton flightId={data.flight.flightId} />}
      <ButtonPrimary href={routes.flight_Detail(props.flightId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={props.trigger}
  >
    {(data) => <FlightSidePanelDetails
      flightSidePanelData={data}
    />}
  </DetailSidePanel>
};

export const useOpenFlightSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openFlightSidePanel = React.useCallback((flightId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Flight.GetSidePanelData(flightId)}
      apiKey="flight"
      entityId={flightId}
      title={RESX.Flight.resxFlight}
      footerContent={data => <>
        {(data.flight.flightType === "commercial" && site.permissions.flight.canCreate) && <AddSegmentButton flightId={data.flight.flightId} />}
        <ButtonPrimary href={routes.flight_Detail(flightId).absolute} label={RESX.Buttons.DetailView} />
      </>}
      skipSidePanelBase
    >
      {(data) => <FlightSidePanelDetails
        flightSidePanelData={data}
      />}
    </DetailSidePanel>, `flight-side-${flightId}`);

  }, [openSidePanel]);

  return openFlightSidePanel;
}